export const STATE = {
	ACTIVE: 'ATIVO',
	UNLOCK: 'DESBLOQUEAR',
	LOCKED: 'DESBLOQUEADO',
	TO_BLOCK: 'BLOQUEAR',
}
